<template>
 <router-view></router-view>
</template>

<script>

import {
  authMethods,
} from "@/state/helpers";

export default {
  name: 'App',
  components: {
  },
  methods: {
    ...authMethods,
  },
  created() {
    this.checkAuthentication();
  }
}
</script>
